import React, { useState } from "react"
import NavButton from "@/components/buttons/nav-button"
import DownChevronIcon from "@/components/icons/down-chevron-icon"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { langStore } from "@/stores/lang-store"
import { Fragment } from "react"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { navBundle } from "./nav-const"

const AptNavs = () => {
  const { lang } = langStore()
  const { region, aptCode } = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const { pickApt } = aptSearchStore()

  const [openMap, setOpenMap] = useState({ stats: true, analysis: false })

  const section = pathname.split("/").at(4)
  const resource = searchParams.get("resource")

  const active = section === "stats" || section === "analysis" ? resource : section

  const toggle = (id) => {
    setOpenMap((v) => ({ ...v, [id]: !v[id] }))
  }

  const goResource = (section, resource) => {
    const params = new URLSearchParams(searchParams)

    params.set("resource", resource)

    const sectionQueries = {
      stats: ["start_date", "end_date"],
      units: ["dong", "ho"]
    }

    const allowedQueries = sectionQueries[section] ?? []

    for (const key of ["start_date", "end_date", "dong", "ho"]) {
      if (!allowedQueries.includes(key)) {
        params.delete(key)
      }
    }

    navigate(`/apt/${region}/${aptCode}/${section}?${params.toString()}`)
  }

  const goPage = (section) => {
    navigate(`/apt/${region}/${aptCode}/${section}`)
  }

  return (
    <nav className="py-4 px-1 space-y-1.5">
      {navBundle.navs.map((nav) => {
        const Icon = nav.icon
        const isGroup = nav.type === "group" && nav.id !== "units"

        if (isGroup) {
          const open = openMap[nav.id]

          return (
            <React.Fragment key={nav.id}>
              <NavButton depth={1} open={open} onClick={() => toggle(nav.id)}>
                <div className="flex items-center gap-3">
                  {Icon && <Icon size={18} className={open ? "text-white" : "text-slate-400"} />}
                  <span>{nav.label[lang]}</span>
                </div>
                <span
                  className="text-slate-400 transition-all duration-300"
                  style={{ transform: open ? "rotate(0deg)" : "rotate(180deg)" }}
                >
                  <DownChevronIcon />
                </span>
              </NavButton>

              {open && (
                <div className="ml-3 pl-1 border-l border-white/10 space-y-0.5">
                  {nav.children.map((c) => {
                    const isChildActive = active === c.id
                    const ChildIcon = c.icon
                    const activeText = c.colors.text
                    const groupHoverText = c.colors.groupHoverText

                    if (pickApt?.heat_type === 1 && ["hotwater", "hot"].includes(c.id)) {
                      return <Fragment key={c.id} />
                    }

                    return (
                      <NavButton
                        key={c.id}
                        depth={2}
                        active={isChildActive}
                        onClick={() => goResource(nav.id, c.id)}
                      >
                        <p className={`flex items-center gap-2.5 w-full`}>
                          {ChildIcon && (
                            <ChildIcon
                              size={15}
                              className={
                                isChildActive
                                  ? activeText
                                  : `text-slate-500 transition-colors ${groupHoverText}`
                              }
                            />
                          )}
                          <span
                            className={
                              isChildActive
                                ? activeText
                                : `text-white transition-colors ${groupHoverText}`
                            }
                          >
                            {c.label[lang]}
                          </span>
                        </p>
                      </NavButton>
                    )
                  })}
                </div>
              )}
            </React.Fragment>
          )
        }

        // 단독 메뉴
        const isItemActive = active === nav.id
        return (
          <NavButton key={nav.id} depth={1} active={isItemActive} onClick={() => goPage(nav.id)}>
            <div className="flex items-center gap-3">
              {Icon && (
                <Icon size={18} className={isItemActive ? "text-white" : "text-slate-400"} />
              )}
              <span>{nav.label[lang]}</span>
            </div>
          </NavButton>
        )
      })}
    </nav>
  )
}

export default AptNavs
